export const HUB_OVERLAY_BACKDROP =
  "pointer-events-none absolute inset-0 z-0 bg-linear-to-b from-background/82 via-background/42 to-transparent backdrop-blur-md dark:from-background/78 dark:via-background/36";

export const PROFILE_OVERLAY_BACKDROP =
  "pointer-events-none absolute inset-0 z-0 bg-linear-to-b from-background/54 via-background/28 to-transparent backdrop-blur-md dark:from-background/48 dark:via-background/24";

const HUB_OVERLAY_MASK_GRADIENT =
  "linear-gradient(to bottom, #000 0%, #000 calc(100% - 0.625rem), transparent 100%)";

export const HUB_OVERLAY_MASK = {
  maskImage: HUB_OVERLAY_MASK_GRADIENT,
  WebkitMaskImage: HUB_OVERLAY_MASK_GRADIENT,
  maskSize: "100% 100%",
  WebkitMaskSize: "100% 100%",
  maskRepeat: "no-repeat",
  WebkitMaskRepeat: "no-repeat",
} as const;

const PROFILE_STICKY_OVERLAY_MASK_GRADIENT =
  "linear-gradient(to bottom, #000 0%, #000 calc(100% - calc(0.625rem + 7px)), transparent 100%)";

export const PROFILE_STICKY_OVERLAY_MASK = {
  maskImage: PROFILE_STICKY_OVERLAY_MASK_GRADIENT,
  WebkitMaskImage: PROFILE_STICKY_OVERLAY_MASK_GRADIENT,
  maskSize: "100% 100%",
  WebkitMaskSize: "100% 100%",
  maskRepeat: "no-repeat",
  WebkitMaskRepeat: "no-repeat",
} as const;

export const HUB_OVERLAY_MASK_BOTTOM_CHROME = {
  maskImage:
    "linear-gradient(to bottom, #000 0%, #000 calc(100% - calc(0.25rem - 2px)), transparent 100%)",
  WebkitMaskImage:
    "linear-gradient(to bottom, #000 0%, #000 calc(100% - calc(0.25rem - 2px)), transparent 100%)",
  maskSize: "100% 100%",
  WebkitMaskSize: "100% 100%",
  maskRepeat: "no-repeat",
  WebkitMaskRepeat: "no-repeat",
} as const;

export const HUB_OVERLAY_TOP =
  "calc(var(--header-height, 3.5rem) + var(--subheader-height, 0px) + var(--contest-banner-height, 0px) + var(--custom-banner-height, 0px))";
